import { Lazy } from "~/tools/lazy";
import { prop } from "~/tools/prop";
import { pullObject } from "~/tools/pull-object";
import type { TemplateVariableValue, TemplateVariables } from "~/tools/template";

export interface TemplateVariableDefinition {
	name: string;
	value: TemplateVariableValue<null>;
	detail?: string;
}

export type TemplateVariableSuggestion = Pick<TemplateVariableDefinition, "name" | "detail">;

export class TemplateVariableDefinitions {
	private readonly lazyValues = Lazy.create(() => pullObject(this.definitions, prop("name"), prop("value")));

	public constructor(private readonly definitions: ReadonlyArray<TemplateVariableDefinition>) {}

	/**
	 * Get the template variable values as a key-value object to use in template interpolation.
	 *
	 * @return The template variable values.
	 */
	public get values(): TemplateVariables<null> {
		return this.lazyValues.get();
	}

	/**
	 * Get the template variable definitions for display purposes in UI components.
	 *
	 * @return An array of template variable definitions with name and detail.
	 */
	public get suggestions(): Array<TemplateVariableSuggestion> {
		return this.definitions as Array<TemplateVariableDefinition>;
	}
}
